import {
  getCareerCounselors,
  getIndustryMentors,
  getCareerCounselorSupportServiceItems,
  getIndustryMentorSupportServiceItems,
  getCareerCounselorById,
  getIndustryMentorById,
  getAllMentorWithSameGroupById
}
  from '~api/career-counselling'

export const state = () => ({
  counselors: [],
  pages: {},
  services: [],
  currentCounselor: {},
  currentCounselorGroupLists: []
})

export const getters = {
  pageGetter: state => state.pages,
  counselorsGetter: state => state.counselors,
  servicesGetter: state => state.services,
  currentCounselorGetter: state => state.currentCounselor,
  currentCounselorGroupListsGetter: state => state.currentCounselorGroupLists
}

export const actions = {
  async getAllCareerCounselors ({ commit }, params) {
    const response = await getCareerCounselors(params)
    const {
      counselors,
      pages
    } = response

    commit('setCounselors', counselors)
    commit('setCounselorsPage', pages)
    return response
  },
  async getAllIndustryMentors ({ commit }, params) {
    const response = await getIndustryMentors(params)
    const {
      mentors,
      pages
    } = response

    commit('setCounselors', mentors)
    commit('setCounselorsPage', pages)
    return response
  },
  async getCareerCounselorDetailById ({ commit }, id) {
    const counselor = await getCareerCounselorById(id)

    commit('setCurrentCounselor', counselor)
    return counselor
  },
  async getIndustryMentorDetailById ({ commit }, id) {
    const counselor = await getIndustryMentorById(id)

    commit('setCurrentCounselor', counselor)
    return counselor
  },
  async getAllCareerCounselorServices ({ commit }) {
    const services = await getCareerCounselorSupportServiceItems()

    commit('setServices', services)
    return services
  },
  async getAllIndustryMentorServices ({ commit }) {
    const services = await getIndustryMentorSupportServiceItems()

    commit('setServices', services)
    return services
  },
  async getAllMentorWithSameGroupById ({ commit }, params) {
    const currentCounselorGroupLists = await getAllMentorWithSameGroupById(params.career, params.group_id)
    commit('setCurrentCounselorGroupLists', currentCounselorGroupLists)
    return currentCounselorGroupLists
  }
}

export const mutations = {
  setCounselors (state, payload) {
    state.counselors = payload
  },
  setCounselorsPage (state, payload) {
    state.pages = payload
  },
  setServices (state, payload) {
    state.services = payload
  },
  setCurrentCounselor (state, payload) {
    state.currentCounselor = payload
  },
  setCurrentCounselorGroupLists (state, payload) {
    state.currentCounselorGroupLists = payload
  }
}
